/* ============================================================
   OCOA Bundle Builder (sections/ocoa-bundle-builder.liquid)
   Figma 29-09-2026 ("CUSTOM OWN BUNDLE"):
   - Card "ADD TO BAG • $24" adds the product to the on-page bundle
   - Panel: helper + segmented progress bar, "Your Custom Bundle (n)",
     one row per product (image, name, discounted / original price, ✕),
     "+ Add Product", One Time / Subscribe (+ frequency) for the WHOLE
     bundle, button "Add Products" → "Add 1 More Item" → "Add to bag • $was $now"
   - Tiers are the section blocks: tier N discount applies at N products
   - Card Subscribe / One time toggles mirror the bundle-level option
   - Bundle is kept in localStorage so a refresh doesn't lose it
   - "Add to bag": ONE /cart/add.js call, optional tier discount code,
     then opens the theme side cart (same events as assets/ocoa-cart.js)
   - < 990px: panel is a sticky bottom bar that expands into a sheet
   ============================================================ */
(function () {
  'use strict';

  var SECTIONS = 'cart-items,cart-footer,cart-item-count,cart-live-region';
  var MOBILE = window.matchMedia('(max-width: 989px)');

  // The shopper's real currency format, learned from "{{ 123456 | money }}" rendered by Liquid
  // (e.g. "$1,234.56", "Rs.1,234.56", "1.234,56 €"). Falls back to shop.money_format.
  function moneyFromSample(cents, sample, keepZeros) {
    var m = sample && sample.match(/^(.*?)1([.,'\s\u00a0]?)234(?:([.,])56)?(.*)$/);
    if (!m) return null;
    var thousands = m[2] || '', dec = m[3] || '.', decimals = m[3] ? 2 : 0;
    var parts = ((cents || 0) / 100).toFixed(decimals).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    var out = parts[1] && (keepZeros || parts[1] !== '00') ? parts[0] + dec + parts[1] : parts[0];
    return m[1] + out + m[4];
  }

  function formatMoney(cents, format) {
    var value = (cents || 0) / 100;
    function fmt(n, decimals, thousands, dec) {
      var parts = n.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      var out = parts.join(dec);
      return out.replace(new RegExp('\\' + dec + '00$'), ''); // "$15.00" -> "$15"
    }
    var f = format || '${{amount}}';
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return fmt(value, 0, ',', '.');
        case 'amount_with_comma_separator': return fmt(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(value, 2, "'", '.');
        default: return fmt(value, 2, ',', '.');
      }
    });
  }

  function storageGet(key) {
    try { return JSON.parse(window.localStorage.getItem(key) || 'null'); } catch (e) { return null; }
  }
  function storageSet(key, val) {
    try { window.localStorage.setItem(key, JSON.stringify(val)); } catch (e) {}
  }
  function parseJSON(str, fallback) {
    try { return JSON.parse(str); } catch (e) { return fallback; }
  }
  function esc(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function openDrawer() {
    try {
      var m = window.Alpine && window.Alpine.store && window.Alpine.store('modals');
      if (!m) return false;
      if (m.rightDrawer) m.rightDrawer.contents = 'cart';
      if (typeof m.open === 'function') m.open('rightDrawer', 'cart');
      if (m.rightDrawer) m.rightDrawer.contents = 'cart';
      return true;
    } catch (e) { return false; }
  }

  var REMOVE_SVG = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true" focusable="false"><circle cx="8" cy="8" r="8" fill="currentColor"/><path d="M10.4362 5.56497L5.56662 10.4345" stroke="#fff" stroke-width="1.5"/><path d="M10.4375 10.4345L5.56794 5.56494" stroke="#fff" stroke-width="1.5"/></svg>';

  function Bundle(root) {
    var cfgEl = root.querySelector('[data-obb-config]');
    if (!cfgEl) return;
    this.cfg = JSON.parse(cfgEl.textContent);
    this.root = root;
    this.tiers = this.cfg.tiers || [];
    this.slots = this.cfg.panelStyle === 'slots';
    this.max = this.slots
      ? Math.max(Math.min(this.cfg.maxItems || this.tiers.length, this.tiers.length), 1)
      : Math.max(this.cfg.maxItems || this.tiers.length, 1);
    this.minItems = Math.max(1, Math.min(this.cfg.minItems || 2, this.max || 1));
    this.key = 'ocoa-bundle:' + this.cfg.sectionId;

    var saved = storageGet(this.key);
    if (Array.isArray(saved)) saved = { items: saved }; // older format
    saved = saved || {};
    this.items = (saved.items || []).slice(0, this.max).filter(function (it) { return it && it.variantId; });
    var mode = saved.mode || this.cfg.defaultMode;
    this.mode = mode === 'subscribe' ? 'subscribe' : 'onetime';
    this.planName = saved.planName || '';
    this.effMode = this.mode;

    this.adoptBagMode = true; // first bag read (and the one after each sync) sets Subscribe / One-time from the bag
    this.removed = {};      // bag lines the shopper took out of the panel (lineKey -> count); the bag itself is untouched until Add
    this.cartGiftIds = {};  // gift variants currently in the bag
    this.panel = root.querySelector('[data-obb-panel]');
    this.backdrop = root.querySelector('[data-obb-backdrop]');
    this.refreshItems();

    this.bindCards();
    this.bindPanel();
    this.render();
    // Phones: show the discounts / tiers once, a couple of seconds after the first visit.
    // The breakpoint and tab visibility are checked when the timer fires (not at load), and the
    // "seen" flag is only saved once the popup was really opened. ?obb_intro=1 forces it again.
    var introKey = 'ocoa-bundle-intro';
    try { if (/[?&]obb_intro=1/.test(window.location.search)) window.localStorage.removeItem(introKey); } catch (e) {}
    // In the theme editor (design mode) the page reloads constantly, so it always shows there.
    var inEditor = !!(window.Shopify && window.Shopify.designMode);
    if (this.cfg.autoOpenMobile !== false && this.panel && (inEditor || !storageGet(introKey))) {
      var selfI = this;
      var tries = 0;
      var tryOpen = function () {
        if ((!inEditor && storageGet(introKey)) || selfI.open) return;
        if (!MOBILE.matches) return;
        if (document.hidden && tries++ < 30) { setTimeout(tryOpen, 1000); return; }
        selfI.setOpen(true);
        if (!inEditor) storageSet(introKey, { seen: 1 });
      };
      setTimeout(tryOpen, Math.max(1, +selfI.cfg.autoOpenDelay || 2) * 1000);
      // Switching the preview from desktop to phone (theme editor, devtools): the media-query
      // "change" event is not reliable there, so also watch the resize itself.
      var wasMobile = MOBILE.matches, rzT;
      var onShrink = function () {
        var m = MOBILE.matches;
        if (m && !wasMobile && (inEditor || !storageGet(introKey)) && !selfI.open) setTimeout(tryOpen, 2000);
        wasMobile = m;
      };
      window.addEventListener('resize', function () { clearTimeout(rzT); rzT = setTimeout(onShrink, 300); });
      MOBILE.addEventListener && MOBILE.addEventListener('change', onShrink);
    }
    var self0 = this;
    this.loadCart();
    // Back button (page restored from cache) or returning to the tab: re-read the bag
    window.addEventListener('pageshow', function (e) { if (e.persisted) self0.loadCart(); });
    document.addEventListener('visibilitychange', function () { if (!document.hidden) self0.loadCart(); });
    var me = this;
    window.addEventListener('resize', function () { me.fitSticky(); });
    window.addEventListener('load', function () { me.fitSticky(); });
  }

  // Saved items keep the price/plans of the visit they were added in (another
  // currency, a price change...). Re-read them from the cards on this page and
  // drop anything that is no longer offered here or is sold out.
  Bundle.prototype.refreshItems = function () {
    var byId = {};
    Array.prototype.forEach.call(this.root.querySelectorAll('[data-obb-size]'), function (el) {
      byId[el.getAttribute('data-variant-id')] = el;
    });
    var self = this;
    this.items = this.items.filter(function (it) {
      var el = byId[String(it.variantId)];
      if (!el || el.getAttribute('data-available') !== 'true') return false;
      it.price = parseInt(el.getAttribute('data-price'), 10) || it.price;
      it.plans = parseJSON(el.getAttribute('data-plans') || '[]', []);
      return true;
    });
    this.save();
  };

  Bundle.prototype.t = function (k) { return (this.cfg.text && this.cfg.text[k]) || ''; };
  Bundle.prototype.money = function (c) {
    return moneyFromSample(c, this.cfg.moneySample) || formatMoney(c, this.cfg.moneyFormat);
  };
  // Card button price keeps its cents ("$22.00", Figma)
  // (large-number currencies like PKR drop the cents so the button text still fits)
  Bundle.prototype.moneyFull = function (c) {
    return moneyFromSample(c, this.cfg.moneySample, (c || 0) < 100000) || formatMoney(c, this.cfg.moneyFormat);
  };
  Bundle.prototype.save = function () {
    storageSet(this.key, { items: this.items.filter(function (it) { return !it.inCart; }), mode: this.mode, planName: this.planName });
  };

  /* ---------- pricing ---------- */
  // Tier for n products; beyond the last tier the last one keeps applying
  Bundle.prototype.tierFor = function (n) {
    if (n < 1 || !this.tiers.length) return null;
    return this.tiers[Math.min(n, this.tiers.length) - 1];
  };
  Bundle.prototype.planFor = function (plans) {
    if (!plans || !plans.length) return null;
    if (this.planName) {
      for (var i = 0; i < plans.length; i++) if (plans[i].name === this.planName) return plans[i];
    }
    return plans[0];
  };
  Bundle.prototype.unitPrice = function (it) {
    if (this.mode === 'subscribe') {
      var p = this.planFor(it.plans);
      if (p) return p.price;
    }
    return it.price;
  };
  Bundle.prototype.totals = function () {
    var self = this;
    var n = this.items.length;
    var tier = this.tierFor(n);
    var pct = tier ? tier.discount : 0;
    var was = 0, total = 0;
    var lines = this.items.map(function (it) {
      var unit = self.unitPrice(it);
      var now = Math.round(unit * (100 - pct) / 100);
      was += it.price;
      total += now;
      return { now: now, was: it.price };
    });
    return { n: n, tier: tier, pct: pct, was: was, total: total, lines: lines };
  };

  /* ---------- cards ---------- */
  Bundle.prototype.activeSize = function (card) {
    return card.querySelector('[data-obb-size].is-active') || card.querySelector('[data-obb-size]');
  };
  Bundle.prototype.cardState = function (card) {
    var size = this.activeSize(card);
    return {
      variantId: parseInt(size.getAttribute('data-variant-id'), 10),
      variantTitle: size.getAttribute('data-variant-title') || '',
      available: size.getAttribute('data-available') === 'true',
      price: parseInt(size.getAttribute('data-price'), 10) || 0,
      plans: parseJSON(size.getAttribute('data-plans') || '[]', []),
      productId: card.getAttribute('data-product-id'),
      title: card.getAttribute('data-title'),
      image: size.getAttribute('data-image') || card.getAttribute('data-image')
    };
  };

  Bundle.prototype.syncCard = function (card) {
    var st = this.cardState(card);
    var hasPlan = st.plans.length > 0;

    // Purchase toggle mirrors the bundle-level option
    var sub = card.querySelector('[data-obb-sub]');
    var one = card.querySelector('[data-obb-one]');
    if (sub && one) {
      var canSub = hasPlan && this.canSubscribe !== false;
      var subOn = this.effMode === 'subscribe' && canSub;
      sub.disabled = !canSub;
      sub.classList.toggle('is-active', subOn);
      one.classList.toggle('is-active', !subOn);
      sub.setAttribute('aria-pressed', subOn);
      one.setAttribute('aria-pressed', !subOn);
    }

    // "ADD TO BAG • $24"
    var btn = card.querySelector('[data-obb-add]');
    var label = card.querySelector('[data-obb-add-label]');
    var dot = card.querySelector('[data-obb-add-dot]');
    var price = card.querySelector('[data-obb-add-price]');
    var full = this.items.length >= this.max;
    btn.disabled = !st.available || full;
    btn.classList.toggle('is-full', full && st.available);
    if (price) price.textContent = this.moneyFull(this.unitPrice(st));
    btn.classList.toggle('is-long', !!price && price.textContent.length > 7);
    var showPrice = this.cfg.atcShowPrice !== false && st.available && !full && !btn.classList.contains('is-added');
    if (dot) dot.hidden = !showPrice;
    if (price) price.hidden = !showPrice;
    if (!btn.classList.contains('is-added')) {
      label.textContent = !st.available ? this.t('soldOut') : full ? this.t('atcFull') : this.t('atc');
    }
  };

  Bundle.prototype.syncCards = function () {
    var self = this;
    (this.cards || []).forEach(function (c) { self.syncCard(c); });
  };

  Bundle.prototype.setMode = function (mode, planName) {
    this.mode = mode === 'subscribe' ? 'subscribe' : 'onetime';
    if (planName !== undefined) this.planName = planName;
    if (this.mode === 'onetime') this.planName = ''; // dropdown back to "Choose an option" (Figma)
    this.save();
    this.render();
  };

  Bundle.prototype.bindCards = function () {
    var self = this;
    this.cards = Array.prototype.slice.call(this.root.querySelectorAll('[data-obb-card]'));
    this.root.addEventListener('click', function (e) {
      var card = e.target.closest('[data-obb-card]');
      if (card) {
        var size = e.target.closest('[data-obb-size]');
        if (size && !size.disabled) {
          card.querySelectorAll('[data-obb-size]').forEach(function (b) {
            var on = b === size;
            b.classList.toggle('is-active', on);
            b.setAttribute('aria-pressed', on);
          });
          self.syncCard(card);
          return;
        }
        if (e.target.closest('[data-obb-sub]')) {
          var st = self.cardState(card);
          var plan = self.planName || (st.plans[0] && st.plans[0].name) || '';
          self.setMode('subscribe', plan);
          return;
        }
        if (e.target.closest('[data-obb-one]')) { self.setMode('onetime'); return; }
        var add = e.target.closest('[data-obb-add]');
        if (add && !add.disabled) { self.add(card, add); return; }
      }
      var more = e.target.closest('[data-obb-more]');
      if (more) {
        self.root.classList.add('is-expanded');
        more.hidden = true;
      }
    });
  };

  Bundle.prototype.add = function (card, btn) {
    if (this.items.length >= this.max) return;
    var st = this.cardState(card);
    if (!st.available) return;
    this.items.push(st);
    this.save();
    this.render();
    var self = this;
    btn.classList.add('is-added');
    card.querySelector('[data-obb-add-label]').textContent = this.t('atcAdded');
    var dot = card.querySelector('[data-obb-add-dot]');
    var price = card.querySelector('[data-obb-add-price]');
    if (dot) dot.hidden = true;
    if (price) price.hidden = true;
    clearTimeout(btn._obbT);
    btn._obbT = setTimeout(function () {
      btn.classList.remove('is-added');
      self.syncCard(card);
    }, 1200);
    if (MOBILE.matches && this.panel) {
      this.panel.classList.remove('is-bump');
      void this.panel.offsetWidth;
      this.panel.classList.add('is-bump');
    }
  };

  // Bundle products already in the bag show in the panel (flagged inCart) so the shopper
  // sees what the bundle holds when coming back to this page. Gifts are not counted.
  // Removing one with the X only changes this panel; the bag is synced by the Add button.
  Bundle.prototype.loadCart = function () {
    var self = this;
    var routes = (window.theme && window.theme.routes) || {};
    return fetch((routes.cart_url || '/cart') + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // keep the header bag badge in step with the bag (the header does not listen for this page's adds)
        document.querySelectorAll('[data-ohdr-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
        var inCart = [], gifts = {}, remLeft = {};
        for (var rkk in self.removed) { remLeft[rkk] = self.removed[rkk]; }
        (cart.items || []).forEach(function (li) {
          var pr = li.properties || {};
          if (!pr._ocoa_bundle) return;
          if (pr._ocoa_bundle_gift) { gifts[li.variant_id] = true; return; }
          var vt = li.variant_title && li.variant_title !== 'Default Title' ? ' · ' + li.variant_title : '';
          // plan options of this variant, read from its card, so the Subscribe / One-time box stays correct
          var holder = self.root.querySelector('[data-obb-size][data-variant-id="' + li.variant_id + '"]');
          var vPlans = holder ? parseJSON(holder.getAttribute('data-plans') || '[]', []) : [];
          var lPlan = (li.selling_plan_allocation && li.selling_plan_allocation.selling_plan) ? li.selling_plan_allocation.selling_plan.name : '';
          var rk = lineId(li.variant_id, lPlan);
          var skip = Math.min(remLeft[rk] || 0, li.quantity); // already taken out of the panel by the shopper
          remLeft[rk] = (remLeft[rk] || 0) - skip;
          for (var q = skip; q < li.quantity; q++) {
            inCart.push({
              variantId: li.variant_id, variantTitle: li.variant_title || '', available: true,
              // one-time list price of the size (a plan line's own price already has the 5% off)
              price: (holder ? parseInt(holder.getAttribute('data-price'), 10) : 0) || li.original_price || li.price, plans: vPlans, productId: String(li.product_id),
              title: li.product_title + vt, image: li.image || '', inCart: true, lineKey: li.key,
              planName: (li.selling_plan_allocation && li.selling_plan_allocation.selling_plan) ? li.selling_plan_allocation.selling_plan.name : ''
            });
          }
        });
        self.cartGiftIds = gifts;
        // After a sync: bundle lines must match what was requested. Any line left over (e.g. an old one-time line
        // next to its new subscription line) is removed by position, using the cart we just read.
        if (self._expected) {
          var exp = self._expected; self._expected = null;
          var fix = cart.items.map(function (x) { return x.quantity; }), dirtyFix = false;
          cart.items.forEach(function (li, pos) {
            var pr2 = li.properties || {};
            if (!pr2._ocoa_bundle || pr2._ocoa_bundle_gift) return;
            var pn = (li.selling_plan_allocation && li.selling_plan_allocation.selling_plan) ? li.selling_plan_allocation.selling_plan.name : '';
            var eid = lineId(li.variant_id, pn);
            var ok = Math.min(exp[eid] || 0, li.quantity);
            exp[eid] = (exp[eid] || 0) - ok;
            if (ok < li.quantity) { fix[pos] = ok; dirtyFix = true; }
          });
          if (dirtyFix) {
            fetch(((window.theme && window.theme.routes && window.theme.routes.cart_update_url) || '/cart/update') + '.js', {
              method: 'POST', credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ updates: fix })
            }).catch(function () {}).then(function () { self.adoptBagMode = true; self.loadCart(); });
            return;
          }
        }
        if (self.adoptBagMode && inCart.length) {
          // the panel shows what the bag holds: Subscribe (with its frequency) if the bundle is on a plan
          var onPlan = inCart.filter(function (it) { return it.planName; })[0];
          self.mode = onPlan ? 'subscribe' : 'onetime';
          if (onPlan) self.planName = onPlan.planName;
          self.adoptBagMode = false;
        } else if (self.adoptBagMode) { self.adoptBagMode = false; }
        var drafts = self.items.filter(function (it) { return !it.inCart; });
        self.items = inCart.concat(drafts).slice(0, self.max);
        self.render();
      })
      .catch(function () {});
  };

  // A bag line is identified by variant + plan, never by its key: Shopify re-keys the lines
  // whenever anything in the cart changes (e.g. the theme adding the free massager).
  function lineId(variantId, planName) { return variantId + '|' + (planName || ''); }

  function giftName(title) {
    return String(title || '').replace(/\s*\(Bundle Gift\)\s*/i, '').replace(/^The\s+/i, '').trim();
  }
  // Gifts the current panel earns ([{id, title}])
  Bundle.prototype.eligibleGifts = function () {
    var tier = this.tierFor(this.items.length);
    return ((tier && tier.gifts) || []).filter(function (g) { return g && g.id; });
  };
  // Plan the panel wants for an item: the chosen frequency when Subscribe is on and the size has it
  Bundle.prototype.wantedPlan = function (it) {
    if (this.mode !== 'subscribe') return null;
    return this.planFor(it.plans) || null;
  };
  // some bag items are on a different option than the panel (Subscribe <-> One-time, or frequency)
  Bundle.prototype.planMismatch = function () {
    var self = this;
    return this.items.some(function (it) {
      if (!it.inCart) return false;
      var w = self.wantedPlan(it);
      return (w ? w.name : '') !== (it.planName || '');
    });
  };
  Bundle.prototype.hasBagBundle = function () {
    if (this.items.some(function (it) { return it.inCart; })) return true;
    for (var k in this.removed) { if (this.removed[k] > 0) return true; }
    for (var g in (this.cartGiftIds || {})) { if (this.cartGiftIds[g]) return true; }
    return false;
  };
  // true when the bag differs from the panel: new picks, items taken out, or gifts out of step
  Bundle.prototype.needsSync = function () {
    if (this.items.some(function (it) { return !it.inCart; })) return true;
    if (this.planMismatch()) return true;
    for (var k in this.removed) { if (this.removed[k] > 0) return true; }
    var want = {}, have = this.cartGiftIds || {}, n = 0, m = 0, i;
    this.eligibleGifts().forEach(function (g) { want[g.id] = true; n++; });
    for (i in have) { if (have[i]) m++; if (!want[i]) return true; }
    return n !== m;
  };

  Bundle.prototype.remove = function (index) {
    var item = this.items[index];
    if (item && item.inCart) {
      // panel only: remember it so a reload of the bag does not bring it back, sync happens on Add
      var rid = lineId(item.variantId, item.planName);
      this.removed[rid] = (this.removed[rid] || 0) + 1;
      this.items.splice(index, 1);
      this.render();
      return;
    }
    this.items.splice(index, 1);
    this.save();
    this.render();
  };

  /* ---------- panel ---------- */
  Bundle.prototype.bindPanel = function () {
    var self = this;
    var toggle = this.root.querySelector('[data-obb-toggle]');
    if (toggle) toggle.addEventListener('click', function () { self.setOpen(!self.open); });
    if (this.backdrop) this.backdrop.addEventListener('click', function () { self.setOpen(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && self.open) self.setOpen(false); });
    if (MOBILE.addEventListener) MOBILE.addEventListener('change', function () { if (!MOBILE.matches) self.setOpen(false); });

    this.root.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-obb-remove]');
      if (rm) { self.remove(parseInt(rm.getAttribute('data-obb-remove'), 10)); return; }
      if (e.target.closest('[data-obb-addmore]')) { self.goToProducts(); return; }
      if (e.target.closest('[data-obb-cta]')) self.checkout();
    });

    this.root.addEventListener('change', function (e) {
      if (e.target.matches('[data-obb-mode]')) {
        self.showError('');
        self.setMode(e.target.value);
      } else if (e.target.matches('[data-obb-plan]')) {
        self.showError('');
        // Picking a frequency means the shopper wants a subscription
        self.setMode(e.target.value ? 'subscribe' : self.mode, e.target.value);
      }
    });
  };

  Bundle.prototype.goToProducts = function () {
    var wasOpen = this.open;
    this.setOpen(false);
    var grid = this.root.querySelector('[data-obb-grid]');
    if (!grid) return;
    // Wait for the sheet's scroll lock to be released, or the browser cancels the scroll
    setTimeout(function () {
      grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, wasOpen ? 80 : 0);
  };

  Bundle.prototype.setOpen = function (open) {
    this.open = !!open;
    if (!this.panel) return;
    this.panel.classList.toggle('is-open', this.open);
    var toggle = this.root.querySelector('[data-obb-toggle]');
    if (toggle) {
      toggle.setAttribute('aria-expanded', this.open);
      toggle.setAttribute('aria-label', this.open ? 'Hide bundle details' : 'Show bundle details');
    }
    if (this.backdrop) this.backdrop.hidden = !this.open;
    document.documentElement.classList.toggle('obb-lock', this.open && MOBILE.matches);
  };

  // Next tier that improves the discount: { need, discount } or null when the best is reached
  Bundle.prototype.nextTier = function (n, pct) {
    for (var j = n; j < this.tiers.length; j++) {
      if (this.tiers[j].discount > pct) return { need: j + 1 - n, discount: this.tiers[j].discount };
    }
    return null;
  };

  Bundle.prototype.renderBar = function (n) {
    // One segment per discount tier: fills from the previous tier's count to this one's
    var html = '', prev = 0, last = 0;
    for (var i = 0; i < this.tiers.length; i++) {
      if (this.tiers[i].discount > last) {
        var c = i + 1;
        var fill = Math.max(0, Math.min(1, (n - prev) / (c - prev)));
        html += '<span class="obb__seg"><span class="obb__seg-fill" style="width:' + (fill * 100) + '%"></span></span>';
        prev = c;
        last = this.tiers[i].discount;
      }
    }
    this.root.querySelectorAll('[data-obb-bar]').forEach(function (el) { el.innerHTML = html; });
  };

  Bundle.prototype.render = function () {
    if (this.slots) return this.renderSlots();
    var self = this;
    var t = this.totals();

    // count in the title "(n)"
    this.root.querySelectorAll('[data-obb-n]').forEach(function (el) { el.textContent = t.n; });

    // helper + progress
    var next = this.nextTier(t.n, t.pct);
    var helper = next
      ? this.t(t.n === 0 ? 'helperEmpty' : 'helperNext').replace('[count]', next.need).replace('[discount]', next.discount)
      : this.t('helperDone').replace('[discount]', t.pct);
    this.root.querySelectorAll('[data-obb-helper]').forEach(function (el) { el.textContent = helper; });
    this.renderBar(t.n);

    // product rows
    var list = this.root.querySelector('[data-obb-items]');
    list.innerHTML = this.items.map(function (it, i) {
      var line = t.lines[i];
      var name = esc(it.title);
      var alt = esc(it.title + (it.variantTitle && it.variantTitle !== 'Default Title' ? ' — ' + it.variantTitle : ''));
      return '<li class="obb-item">' +
        '<span class="obb-item__img">' + (it.image ? '<img src="' + esc(it.image) + '" alt="' + alt + '" width="67" height="69" loading="lazy">' : '') + '</span>' +
        '<span class="obb-item__info">' +
          '<span class="obb-item__name">' + name + '</span>' +
          '<span class="obb-item__prices">' +
            '<span class="obb-item__now">' + self.money(line.now) + '</span>' +
            (line.was > line.now ? '<s class="obb-item__was">' + self.money(line.was) + '</s>' : '') +
          '</span>' +
        '</span>' +
        '<button type="button" class="obb-item__remove" data-obb-remove="' + i + '" aria-label="' + esc(self.t('remove') + ' ' + it.title) + '">' + REMOVE_SVG + '</button>' +
      '</li>';
    }).join('');
    this.root.querySelector('[data-obb-addmore]').hidden = t.n >= this.max;

    // purchase option (shown once something is in the bundle)
    var box = this.root.querySelector('[data-obb-purchase-box]');
    box.hidden = t.n === 0;
    var names = [];
    this.items.forEach(function (it) {
      (it.plans || []).forEach(function (p) { if (names.indexOf(p.name) === -1) names.push(p.name); });
    });
    var subOpt = this.root.querySelector('[data-obb-sub-opt]');
    var noPlans = names.length === 0;
    subOpt.classList.toggle('is-disabled', noPlans);
    subOpt.querySelector('[data-obb-mode]').disabled = noPlans;
    this.root.querySelector('[data-obb-sub-note]').hidden = !noPlans;
    // Items in the bundle but none of them can be subscribed: one time only,
    // and the cards' Subscribe buttons are disabled so both controls always agree
    this.canSubscribe = t.n === 0 || names.length > 0;
    if (!this.canSubscribe) this.mode = 'onetime';
    var effMode = this.mode;
    this.effMode = effMode;
    this.root.querySelectorAll('[data-obb-mode]').forEach(function (r) { r.checked = r.value === effMode; });
    // Subscribe chosen (e.g. from a card) without a frequency yet: preselect the first one
    if (effMode === 'subscribe' && names.length && names.indexOf(this.planName) === -1) this.planName = names[0];
    var sel = this.root.querySelector('[data-obb-plan]');
    var placeholder = sel.options[0] ? sel.options[0].outerHTML : '<option value=""></option>';
    sel.innerHTML = placeholder + names.map(function (nm) {
      return '<option value="' + esc(nm) + '"' + (nm === self.planName ? ' selected' : '') + '>' + esc(nm) + '</option>';
    }).join('');
    if (names.indexOf(this.planName) === -1 || effMode === 'onetime') sel.value = '';
    sel.disabled = noPlans;
    subOpt.classList.toggle('is-active', effMode === 'subscribe');

    // button
    var busy = this.busy;
    var label, showPrice = false, action;
    if (t.n === 0) { label = this.t('ctaEmpty'); action = 'browse'; }
    else if (t.n < this.minItems) { label = this.t('ctaMore').replace('[count]', this.minItems - t.n); action = 'browse'; }
    else { label = this.t('ctaAdd'); showPrice = true; action = 'checkout'; }
    if (busy) { label = this.t('ctaAdding'); showPrice = false; }
    this.ctaAction = action;
    this.root.querySelector('[data-obb-cta-label]').textContent = label;
    this.root.querySelector('[data-obb-cta-dot]').hidden = !showPrice;
    var was = this.root.querySelector('[data-obb-cta-was]');
    was.hidden = !showPrice || t.was <= t.total;
    was.textContent = this.money(t.was);
    var price = this.root.querySelector('[data-obb-cta-price]');
    price.hidden = !showPrice;
    price.textContent = this.money(t.total);
    this.root.querySelector('[data-obb-cta]').disabled = !!busy;

    this.root.classList.toggle('has-items', t.n > 0);
    this.syncCards();
    var self2 = this;
    window.requestAnimationFrame(function () { self2.fitSticky(); });
  };

  // Desktop sticky box: normally sticks below the header; when it is taller than
  // the screen, stick it by its bottom instead so "Add to bag" stays reachable.
  Bundle.prototype.fitSticky = function () {
    var p = this.panel;
    if (!p) return;
    if (MOBILE.matches) { p.style.top = ''; return; }
    var base = parseFloat(getComputedStyle(this.root).getPropertyValue('--obb-sticky-top')) || 140;
    var top = Math.min(base, window.innerHeight - p.offsetHeight - 20);
    p.style.top = top + 'px';
  };

  // Plan names available for the products currently in the bundle
  Bundle.prototype.planNames = function () {
    var names = [];
    this.items.forEach(function (it) {
      (it.plans || []).forEach(function (p) { if (names.indexOf(p.name) === -1) names.push(p.name); });
    });
    return names;
  };

  /* ---------- "Slots + free gifts" style (Figma Design V1 + hover state) ---------- */
  Bundle.prototype.renderSlots = function () {
    var self = this;
    var root = this.root;
    var n = this.items.length;
    var names = this.planNames();
    this.canSubscribe = n === 0 || names.length > 0;
    if (!this.canSubscribe) this.mode = 'onetime';
    if (this.mode === 'subscribe' && names.length && names.indexOf(this.planName) === -1) this.planName = names[0];
    this.effMode = this.mode;

    // totals for both purchase options (the selector shows both)
    var tier = this.tierFor(n);
    var pct = tier ? tier.discount : 0;
    var was = 0, one = 0, sub = 0;
    this.items.forEach(function (it) {
      was += it.price;
      one += Math.round(it.price * (100 - pct) / 100);
      var p = self.planFor(it.plans);
      sub += Math.round((p ? p.price : it.price) * (100 - pct) / 100);
    });
    var total = this.mode === 'subscribe' ? sub : one;

    // slots
    root.querySelectorAll('[data-obb-slot]').forEach(function (slot, i) {
      var pick = slot.querySelector('[data-obb-slot-pick]');
      var item = self.items[i];
      slot.classList.toggle('is-filled', !!item);
      var old = pick.querySelector('.obb-slot__item');
      if (old) old.remove();
      if (item) {
        var alt = esc(item.title + (item.variantTitle && item.variantTitle !== 'Default Title' ? ' — ' + item.variantTitle : ''));
        pick.insertAdjacentHTML('beforeend',
          '<div class="obb-slot__item">' +
            (item.image ? '<img src="' + esc(item.image) + '" alt="' + alt + '" width="50" height="50" loading="lazy">' : '') +
            '<button type="button" class="obb-slot__remove" data-obb-remove="' + i + '" aria-label="' + esc(self.t('remove') + ' ' + item.title) + '">' +
              '<svg width="12" height="12" viewBox="0 0 11.959 11.959" fill="none" aria-hidden="true" focusable="false"><circle cx="5.97949" cy="5.97949" r="5.97949" fill="currentColor"/><path d="M7.88907 4.00635L3.88281 8.01261" stroke="#fff"/><path d="M7.89062 8.01261L3.88436 4.00635" stroke="#fff"/></svg>' +
            '</button>' +
          '</div>');
      }
    });

    // helper
    var next = this.nextTier(n, pct);
    var helper = n === 0 ? this.t('helperEmpty').replace('[count]', next ? next.need : 1).replace('[discount]', next ? next.discount : 0)
      : next ? this.t('helperNext').replace('[count]', next.need).replace('[discount]', next.discount)
      : this.t('helperDone').replace('[discount]', pct);
    root.querySelectorAll('[data-obb-helper]').forEach(function (el) { el.textContent = helper; });

    // mobile bar pill "4 Product"
    var count = root.querySelector('[data-obb-count]');
    if (count) {
      count.textContent = (this.t('count') || '[count] Product').replace('[count]', n);
      count.hidden = n === 0;
    }

    // summary
    root.querySelector('[data-obb-summary]').hidden = n === 0;
    root.querySelector('[data-obb-pct]').textContent = pct;
    root.querySelector('[data-obb-discount]').textContent = (was - one > 0 ? '-' : '') + this.money(was - one);
    // Subscribe adds its own saving on top of the bundle %: show it so list - discount - subscription = Amount
    var ssRow = root.querySelector('[data-obb-subsave-row]');
    if (ssRow) {
      var subSave = one - sub;
      var showSS = this.mode === 'subscribe' && subSave > 0;
      ssRow.hidden = !showSS;
      if (showSS) {
        root.querySelector('[data-obb-subsave]').textContent = '-' + this.money(subSave);
        root.querySelector('[data-obb-subpct]').textContent = Math.round((1 - sub / one) * 100);
      }
    }
    var gl = root.querySelector('[data-obb-gift-label]');
    var eg = this.eligibleGifts();
    if (gl) gl.textContent = eg.length ? eg.map(function (g) { return giftName(g.title); }).join(' + ') : (this.t('noGift') || 'No free gift');
    root.querySelector('[data-obb-gift]').textContent = eg.length ? (this.t('giftFree') || 'FREE') : '';
    var wasEl = root.querySelector('[data-obb-was]');
    wasEl.textContent = this.money(was);
    wasEl.hidden = was <= total;
    root.querySelector('[data-obb-total]').textContent = this.money(total);

    // Subscribe every [frequency] / One-time
    var opts = root.querySelector('[data-obb-buy-opts]');
    opts.hidden = n === 0;
    var noPlans = names.length === 0;
    var subRow = root.querySelector('[data-obb-sub-opt]');
    subRow.classList.toggle('is-disabled', noPlans);
    subRow.querySelector('[data-obb-mode]').disabled = noPlans;
    root.querySelector('[data-obb-sub-note]').hidden = !noPlans || n === 0;
    root.querySelectorAll('[data-obb-mode]').forEach(function (r) { r.checked = r.value === self.mode; });
    var sel = root.querySelector('[data-obb-plan]');
    var shown = names.length ? names : [this.t('noPlan') || '—'];
    // "Delivery every 2 months" -> "2 Months" (reads "Subscribe every 2 Months", Figma)
    var short = function (nm) {
      var t = String(nm).replace(/^\s*(delivery|deliver|ships?|subscribe)\s+every\s+/i, '');
      return t.replace(/\b([a-z])/g, function (c) { return c.toUpperCase(); });
    };
    sel.innerHTML = shown.map(function (nm) {
      return '<option value="' + (names.length ? esc(nm) : '') + '"' + (nm === (self.planName || names[0]) ? ' selected' : '') + '>' + esc(names.length ? short(nm) : nm) + '</option>';
    }).join('');
    sel.disabled = noPlans;
    var subWas = root.querySelector('[data-obb-sub-was]');
    subWas.textContent = this.money(one);
    subWas.hidden = noPlans || one <= sub;
    root.querySelector('[data-obb-sub-now]').textContent = noPlans ? '' : this.money(sub);
    root.querySelector('[data-obb-one-now]').textContent = this.money(one);

    // button
    var busy = this.busy, label, showPrice = false, action;
    var draftN = this.items.filter(function (it) { return !it.inCart; }).length;
    var dirty = this.needsSync();
    if (n === 0 && !dirty) { label = this.t('ctaEmpty'); action = 'browse'; }
    else if (!dirty) { label = this.t('ctaEmpty'); action = 'browse'; }
    else if (n === 0) { label = this.t('ctaUpdate') || 'Update bundle'; action = 'checkout'; }
    else if (n < this.minItems) { label = this.t('ctaMore').replace('[count]', this.minItems - n); action = 'browse'; }
    else { label = this.hasBagBundle() ? (this.t('ctaUpdate') || 'Update bundle') : this.t('ctaAdd'); showPrice = true; action = 'checkout'; }
    if (busy) { label = this.hasBagBundle() ? (this.t('ctaUpdating') || 'Updating...') : this.t('ctaAdding'); showPrice = false; }
    this.ctaAction = action;
    root.querySelector('[data-obb-cta-label]').textContent = label;
    root.querySelector('[data-obb-cta-dot]').hidden = !showPrice;
    root.querySelector('[data-obb-cta-was]').hidden = true;
    var price = root.querySelector('[data-obb-cta-price]');
    price.hidden = !showPrice;
    price.textContent = this.money(total); // whole bundle, same number as the Amount row
    root.querySelector('[data-obb-cta]').disabled = !!busy;

    root.classList.toggle('has-items', n > 0);
    this.syncCards();
    window.requestAnimationFrame(function () { self.fitSticky(); });
  };

  Bundle.prototype.showError = function (msg) {
    var el = this.root.querySelector('[data-obb-error]');
    el.textContent = msg || '';
    el.hidden = !msg;
  };

  // Add button: make the bag match the panel. New picks are added, items taken out of the panel
  // are removed from the bag, and the gifts of the current tier are added / the others removed.
  Bundle.prototype.checkout = function () {
    var self = this;
    this.showError('');
    if (this.ctaAction !== 'checkout') { this.goToProducts(); return; }
    if (this.busy) return;
    var drafts = this.items.filter(function (it) { return !it.inCart; });
    var kept = this.items.filter(function (it) { return it.inCart; });
    if (drafts.length && this.mode === 'subscribe' && !this.planName) {
      this.showError(this.t('planRequired'));
      var sel = this.root.querySelector('[data-obb-plan]');
      if (sel) sel.focus();
      return;
    }

    var bundleId = 'B' + Date.now().toString(36);
    var routes = (window.theme && window.theme.routes) || {};
    var eff = this.tierFor(this.items.length);
    var eligible = this.eligibleGifts();
    var wantGift = {};
    eligible.forEach(function (g) { wantGift[g.id] = true; });
    var keepLeft = {};   // how many of each variant+plan the panel still wants in the bag
    kept.forEach(function (it) { var id = lineId(it.variantId, it.planName); keepLeft[id] = (keepLeft[id] || 0) + 1; });
    var effPct = eff ? eff.discount : 0;
    var code = eff && eff.code;
    var last = null;
    var pendingExpected = null; // checked by loadCart once the whole sync is done

    this.busy = true;
    this.render();
    // Leaving the page mid-sync must not bring the picked products back next to the bagged ones
    storageSet(this.key, { items: [], mode: this.mode, planName: this.planName });

    function post(url, body) {
      return fetch(url, {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok || data.status) throw new Error(data.description || data.message || self.t('error'));
          return data;
        });
      });
    }

    fetch((routes.cart_url || '/cart') + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // Quantities are sent BY POSITION (one number per cart line, in cart order) instead of by line key:
        // keys change whenever the cart changes, and a stale key makes the request silently do nothing.
        var qtyArr = cart.items.map(function (x) { return x.quantity; });
        var posOf = function (x) { return cart.items.indexOf(x); };
        var hasUpdates = false, haveGift = {}, rebuild = [], snapshot = [];
        (cart.items || []).forEach(function (li) {
          var pr = li.properties || {};
          if (!pr._ocoa_bundle) return;
          if (pr._ocoa_bundle_gift) {
            haveGift[li.variant_id] = true;
            if (!wantGift[li.variant_id]) { qtyArr[posOf(li)] = 0; hasUpdates = true; }   // no longer earned
          } else {
            var curName0 = (li.selling_plan_allocation && li.selling_plan_allocation.selling_plan) ? li.selling_plan_allocation.selling_plan.name : '';
            var lid = lineId(li.variant_id, curName0);
            var want = Math.min(keepLeft[lid] || 0, li.quantity);
            keepLeft[lid] = (keepLeft[lid] || 0) - want;
            // Subscribe <-> One-time / new frequency for lines that stay in the bag
            var rep = want > 0 ? kept.filter(function (it) { return it.variantId === li.variant_id && (it.planName || '') === curName0; })[0] : null;
            var wp = rep ? self.wantedPlan(rep) : null;
            var curName = (li.selling_plan_allocation && li.selling_plan_allocation.selling_plan) ? li.selling_plan_allocation.selling_plan.name : '';
            if (rep && (wp ? wp.name : '') !== curName) {
              // plan switch = take the line out and put it back on the new plan, all lines in ONE update + ONE add
              // (a request per line re-draws the cart each time and is very slow)
              var curPlanId = (li.selling_plan_allocation && li.selling_plan_allocation.selling_plan) ? li.selling_plan_allocation.selling_plan.id : null;
              var nl = { id: li.variant_id, quantity: want, properties: li.properties };
              if (wp) nl.selling_plan = wp.id;
              rebuild.push(nl);
              var ol = { id: li.variant_id, quantity: li.quantity, properties: li.properties };
              if (curPlanId) ol.selling_plan = curPlanId;
              snapshot.push(ol);
              qtyArr[posOf(li)] = 0; hasUpdates = true;
            } else if (want !== li.quantity) { qtyArr[posOf(li)] = want; hasUpdates = true; } // taken out of the panel
          }
        });

        var lines = [];
        var props = { _ocoa_bundle: bundleId, _ocoa_bundle_tier: String(self.items.length), _ocoa_bundle_discount: effPct + '%' };
        drafts.forEach(function (it) {
          var planId = null;
          if (self.mode === 'subscribe') {
            var p = self.planFor(it.plans);
            if (p) planId = p.id;
          }
          // merge identical lines (same variant + plan) into one quantity
          var same = lines.filter(function (l) { return l.id === it.variantId && (l.selling_plan || null) === planId; })[0];
          if (same) { same.quantity += 1; return; }
          var line = { id: it.variantId, quantity: 1, properties: props };
          if (planId) line.selling_plan = planId;
          lines.push(line);
        });
        eligible.forEach(function (g) {
          if (haveGift[g.id]) return;
          // number of products from which this gift is earned (first tier that lists it)
          var minN = 0;
          for (var ti = 0; ti < self.tiers.length && !minN; ti++) {
            if ((self.tiers[ti].gifts || []).some(function (x) { return x && x.id === g.id; })) minN = ti + 1;
          }
          lines.push({ id: g.id, quantity: 1, properties: { _ocoa_bundle: bundleId, _ocoa_bundle_gift: 'true', _ocoa_bundle_gift_min: String(minN || 3) } });
        });

        // First-subscription massager (the theme adds it when any line is on a plan, unless the bundle already gives
        // its own massager). Doing it here saves the extra cart change the theme would make after us.
        var cfgSG = self.cfg.subGiftEnabled && self.cfg.subGiftVariant;
        if (cfgSG) {
          var otherSub = cart.items.some(function (x) {
            var xp = x.properties || {};
            return !xp._ocoa_bundle && !xp._ocoa_subscription_gift && !xp._ocoa_threshold_gift && x.selling_plan_allocation;
          });
          var willSub = otherSub || kept.some(function (it) { return !!self.wantedPlan(it); }) ||
            drafts.some(function (it) { return self.mode === 'subscribe' && !!self.planFor(it.plans); });
          var bundleMass = eligible.some(function (g) { return /massager/i.test(g.title || ''); });
          var wantSub = willSub && !bundleMass;
          var subLines = cart.items.filter(function (x) { return (x.properties || {})._ocoa_subscription_gift === 'true'; });
          if (!wantSub) {
            subLines.forEach(function (x) { qtyArr[posOf(x)] = 0; hasUpdates = true; });
          } else if (!subLines.length) {
            lines.push({ id: self.cfg.subGiftVariant, quantity: 1, properties: { _ocoa_subscription_gift: 'true' } });
          }
        }

        // what the bag must look like afterwards; loadCart checks it and repairs leftovers
        var expected = {};
        kept.forEach(function (it) { var w = self.wantedPlan(it); var id = lineId(it.variantId, w ? w.name : ''); expected[id] = (expected[id] || 0) + 1; });
        drafts.forEach(function (it) {
          var w = self.mode === 'subscribe' ? self.planFor(it.plans) : null;
          var id = lineId(it.variantId, w ? w.name : ''); expected[id] = (expected[id] || 0) + 1;
        });
        pendingExpected = expected;

        var chain = Promise.resolve();
        var allLines = rebuild.concat(lines);
        if (hasUpdates) {
          var upd = { updates: qtyArr };
          if (!allLines.length) { upd.sections = SECTIONS; upd.sections_url = window.location.pathname; } // the last request re-draws the cart
          chain = chain.then(function () {
            return post((routes.cart_update_url || '/cart/update') + '.js', upd).then(function (d) { last = d; });
          });
        }
        if (allLines.length) {
          chain = chain.then(function () {
            return post((routes.cart_add_url || '/cart/add') + '.js', { items: allLines, sections: SECTIONS, sections_url: window.location.pathname })
              .then(function (d) { last = d; })
              .catch(function (err) {
                // the switched lines were taken out first: put them back as they were, then report the error
                if (!snapshot.length) throw err;
                return post((routes.cart_add_url || '/cart/add') + '.js', { items: snapshot })
                  .catch(function () {})
                  .then(function () { throw err; });
              });
          });
        }
        return chain;
      })
      .then(function () {
        var applyCode = code
          ? fetch('/discount/' + encodeURIComponent(code) + '?redirect=/cart.js', { credentials: 'same-origin' }).catch(function () {})
          : Promise.resolve();
        return applyCode;
      })
      .then(function () {
        self.removed = {};
        self.items = [];
        self.adoptBagMode = true;
        self._expected = pendingExpected;
        self.save();
        self.loadCart();
        self.setOpen(false);
        document.body.dispatchEvent(new CustomEvent('shapes:modalcart:afteradditem', {
          bubbles: true, detail: { response: last || {}, originalTarget: self.root }
        }));
        if (!openDrawer()) window.location.href = (routes.cart_url || '/cart');
      })
      .catch(function (err) { self.save(); self.showError(err && err.message ? err.message : self.t('error')); })
      .finally(function () { self.busy = false; self.render(); });
  };

  function init(scope) {
    (scope || document).querySelectorAll('[data-obb]').forEach(function (root) {
      if (root._obb) return;
      root._obb = new Bundle(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  // Theme editor: re-init when the section is re-rendered
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
